<template>
    <section class="result">
      <div class="inputs">
        <label for="height">Cena [zł/kg]</label>
        <input name='price' v-model="price" />
      </div>
      <div class="inputs half">
        <label for="height">Waga [kg]</label>
        <input name='weight' :value="wynik()" readonly/>
      </div>
      <div class="inputs half">
        <label for="height half">Wartość [zł]</label>
        <input name='worth' :value="cost()" readonly/>
      </div>
    </section>

</template>

<script>

export default {
  name: 'Result',
  props: ['g', 'profile', 'height', 'outerDiameter', 'size', 'width', 'innerDiameter', 'wallSize', 'lenght'],
  data() {
    return {
      weight: 0,
      price: 0,
      value: 0,
      result: '',
    };
  },
  methods: {
    wynik() {
      console.log(`Twój profil to ${this.profile}`);
      switch (this.profile) {
        case '1': {
          const pi = Math.PI;
          const r = (this.outerDiameter / 2) / 100;
          const l = (this.lenght / 100);
          const p = pi * (r ** 2);
          this.result = this.zaokr(p * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '2': {
          const pi = Math.PI;
          const r = (this.outerDiameter / 2) / 100;
		      const r2 = (r - (this.wallSize / 100));
		      const l = (this.lenght) / 100;
		      const p1 = pi * (r ** 2);
		      const p2 = pi * (r2 ** 2);
		      this.result = this.zaokr((p1 - p2) * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '3': {
          const h = (this.height / 2) / 100;
          const l = (this.lenght) / 100;
          const p = 2 * (h ** 2) * Math.sqrt(3);
          this.result = this.zaokr(p * l * this.g, 3);
          console.log(`${h}, ${l}, ${p}`)
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '4': {
          const pi = Math.PI;
          const h = (this.height) / 100;
          const b = (this.innerDiameter) / 100;
          const l = (this.lenght) / 100;
          const p1 = 2 * (h ** 2) * Math.sqrt(3);
          const p2 = pi * (b ** 2);
          this.result = this.zaokr((p1 - p2) * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '5': {
          const w = this.width / 100;
          const l = this.lenght / 100;
          const p = w * w;
          this.result = this.zaokr(p * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '6': {
          const h = (this.size) / 100;
          const w = (this.width) / 100;
          const l = (this.lenght) / 100;
          const p = h * w;
          this.result = this.zaokr(p * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '7': {
          const h = (this.height) / 100;
          const w = (this.width) / 100;
          const b = (this.wallSize) / 100;
          const l = (this.lenght) / 100;
          const p1 = h * w;
          const p2 = (h - (2 * b)) * (w - (2 * b));
          this.result = this.zaokr((p1 - p2) * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '8': {
          const h = (this.height) / 100;
          const w = (this.width) / 100;
          const b = (this.wallSize) / 100;
          const l = (this.lenght) / 100;
          const p1 = h * w;
          const p2 = (h - b) * (w - b);
          this.result = this.zaokr((p1 - p2) * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '9': {
          const h = (this.height) / 100;
          const w = (this.width) / 100;
          const b = (this.wallSize) / 100;
          const l = (this.lenght) / 100;
          const p1 = h * w;
          const p2 = (h - (2 * b)) * (w - b);
          this.result = this.zaokr((p1 - p2) * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '10': {
          const h = (this.height) / 100;
          const w = (this.width) / 100;
          const b = (this.wallSize) / 100;
          const l = (this.lenght) / 100;
          const p1 = h * w;
          const p2 = (h - b) * (w - b);
          this.result = this.zaokr((p1 - p2) * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        case '11': {
          const h = (this.height) / 100;
          const w = (this.width) / 100;
          const b = (this.wallSize) / 100;
          const l = (this.lenght) / 100;
          const p1 = h * w;
          const p2 = (h - (2 * b)) * (w - b);
          this.result = this.zaokr((p1 - p2) * l * this.g, 3);
          console.log(`Wynik to ${this.result}`);
          return (this.result).toFixed(2);
          break;
        }
        default: {
          console.log(`Wybierz profil 1 - 11 ${this.profile}`);
        }
      }
    },
    zaokr(l, n) {
      const r = (10 ** n);
      return Math.round(l * r) / r;
    },
    cost() {
      this.value = parseFloat(this.price.toString().replace(',', '.')) * this.result;
      return (this.value).toFixed(2);
    },
  },
};
</script>

<style scoped>

  .result{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .result .inputs{
    flex: 0 0 100%;
    max-width: 100%;
  }

  .result .inputs.half{
    flex: 0 0 49%;
    max-width: 49%;
  }

  .result .inputs.half label{
    max-width: 54%;
    padding: 5px 0 5px 5px;
  }
  
  .result .inputs.half input{
    text-align: center;
    max-width: 46%;
  }

  @media (max-width: 400px) {
    .result .inputs.half{
      flex: 0 0 100%;
      max-width: 100%;
      display: flex;
    }
    .result .inputs.half label{
      padding: 5px 0 5px 15px;
      flex: 0 0 66.666%;
      max-width: 66.666%;
    }
    .result .inputs.half input{
      flex: 0 0 33.3333%;
      max-width: 33.3333%;
      text-align: right;
      padding:0 15px;
    }
  }

</style>
